export default __webpack_public_path__ + "1f130c9d16c381f139e11865aee80e86.svg";